// Canonical deployments: C:/126/files/ethflo.txt (mainnet 2026-04-02) + Sepolia table

export const SUPPORTED_CHAIN_IDS = [11155111, 1] as const
export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number]

export interface ChainAddresses {
  router: string
  v3Factory: string
  stableFactory: string
  cpmmFactory: string
  feeSplitter: string
  kvhToken: string
  weth: string
  /** KavachV3Periphery — V3 add/remove/collect (use this; matches repo contracts/KavachV3Periphery.sol) */
  v3Periphery: string
  /** KavachV3SwapPeriphery — optional standalone V3 swaps */
  v3SwapPeriphery: string
  /** Legacy thin mint helper (optional; only if you still use it) */
  v3MintHelper: string
  /** Unused by UI — CPMM uses direct pool transfer + mint / factory.initializePool */
  cpmmLiqHelper: string
  defaultFeeRecipient: string
}

export const ADDRESSES: Record<SupportedChainId, ChainAddresses> = {
  11155111: {
    router: '0x2d483dEECb4630B3f8aeEb4Cd618c522189fED8F',
    v3Factory: '0xD13379d75D35075119Ac7c8C6595BCA43796D42E',
    stableFactory: '0xe6B0feD2c3c1c9dDf8183180DfB6C5e8ed968051',
    cpmmFactory: '0xb82776c30509c44e0D66763F623B3b054d540338',
    feeSplitter: '0x8CE08111c2d1Aab5eE2340975944fc144b2A0828',
    kvhToken: '0x4C75e28e43F7BA8460122E6F1C2F62242d5fdaeE',
    weth: '0xFFF9976782D46CC05630D1f6EbaB18Bfc4d34eF6',
    v3Periphery: '0x4F17b12Db03A379bA78cA275Ed882bD0917DE9f3',
    v3SwapPeriphery: '0x048e1BF6335f1221Bd51aDC33ec0FBdD73a4E1E2',
    v3MintHelper: '',
    cpmmLiqHelper: '',
    defaultFeeRecipient: '0xE08a4D0D0732689F7427d7Dca5305F116Ab9Ad65',
  },
  1: {
    router: '0x4C75e28e43F7BA8460122E6F1C2F62242d5fdaeE',
    v3Factory: '0x4d659c45CA59f04C9a5c0C4Ce7c22e64faE47c2F',
    stableFactory: '0xCe7837aC2C699c6c09366Ce501A98B0e1193C4FC',
    cpmmFactory: '0x683114097627927d8fd21B817151724F55a27B44',
    feeSplitter: '0xC032CfA3e8fCa70102E443b836071889551b42DF',
    kvhToken: '0xD13379d75D35075119Ac7c8C6595BCA43796D42E',
    weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    v3Periphery: '0xe6B0feD2c3c1c9dDf8183180DfB6C5e8ed968051',
    v3SwapPeriphery: '0xb82776c30509c44e0D66763F623B3b054d540338',
    v3MintHelper: '',
    cpmmLiqHelper: '',
    defaultFeeRecipient: '0xE08a4D0D0732689F7427d7Dca5305F116Ab9Ad65',
  },
}

export function getAddresses(chainId: number): ChainAddresses | null {
  if (chainId === 11155111 || chainId === 1) {
    return ADDRESSES[chainId as SupportedChainId]
  }
  return null
}

export const V3_FEE_TIERS = [
  { fee: 100, label: '0.01%', tickSpacing: 1 },
  { fee: 200, label: '0.02%', tickSpacing: 4 },
  { fee: 300, label: '0.03%', tickSpacing: 6 },
  { fee: 400, label: '0.04%', tickSpacing: 8 },
  { fee: 500, label: '0.05%', tickSpacing: 10 },
  { fee: 2500, label: '0.25%', tickSpacing: 50 },
  { fee: 3000, label: '0.30%', tickSpacing: 60 },
  { fee: 10000, label: '1.00%', tickSpacing: 200 },
  { fee: 20000, label: '2.00%', tickSpacing: 400 },
  { fee: 30000, label: '3.00%', tickSpacing: 600 },
] as const

export const CPMM_FEE_TIERS = [100, 200, 300, 400, 500, 2500, 3000, 10000, 20000, 30000] as const

export const CHAIN_NAMES: Record<number, string> = {
  1: 'Ethereum',
  11155111: 'Sepolia',
}

export const BLOCK_EXPLORERS: Record<number, string> = {
  1: 'https://etherscan.io',
  11155111: 'https://sepolia.etherscan.io',
}
